<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="알림" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="full">
          <div class="appNotiTop">
            <span class="tit" v-if="userInfo && !!userInfo">
              <em>{{ userInfo.userName }}님</em>
              을 위한 알림
            </span>
            <span class="tit" v-if="userInfo == '' || userInfo == null">
              <em>고객님</em>
              을 위한 알림
            </span>
            <div class="linkGroup">
              <button type="button" class="links underline" @click="readNotiAllDel()">읽은 알림 삭제</button>
              <button type="button" class="links underline" @click="notiAllDel()">전체 삭제</button>
            </div>
          </div>

          <div class="resultMsg appNoti" v-if="appNotiList && appNotiList.length == 0">
            <template v-if="userInfo && !!userInfo">
              <p class="copy">새로운 알림이 없습니다.</p>
            </template>
            <template v-else>
              <p class="copy">새로운 알림이 없습니다.</p>
              <p class="desc">
                로그인하시면,
                <br />
                유용한 알림을 받아보실 수 있습니다.
              </p>
              <button type="button" class="btn_l m" @click="$router.replace('/login')">로그인</button>
            </template>
          </div>

          <!-- div class="resultMsg appNoti" v-if="(userInfo=='' || userInfo==null)">
            <p class="copy">새로운 알림이 없습니다.</p>
            <p class="desc">
              로그인하시면,
              <br />
              유용한 알림을 받아보실 수 있습니다.
            </p>
            <button type="button" class="btn_l m" @click="$router.replace('/login')">로그인</button>
          </div -->
          <ul class="appNotiList" v-if="appNotiList && appNotiList.length > 0">
            <li v-for="(value, key) in appNotiList" :key="key" v-bind:class="{ read: value.readYn == 'Y' }">
              <a @click="notiDetail(value)" class="block">
                <p class="tit">{{ value.msgTitl }}</p>
                <span class="cont">
                  {{ value.msgCntn }}
                </span>
                <!-- div class="imgArea">
                  <span class="img imgCover"><img src="@/../static/img/mw/temp/temp_product02.png" alt="NEW 웰릭스 음식물처리기 DK-W2020" /></span>
                </div -->
                <span class="date">
                  <span class="blind">수신일</span>
                  <!-- span>{{value.msgDt.substr(0,8)==nowdt?value.msgDt.substr(8,6):value.msgDt.substr(0,8)}}</span -->
                  <span>{{ value.msgDt.substr(0, 8) | dateFormatter('-') }}</span>
                </span>
              </a>
              <button type="button" class="swipeBtn del">삭제</button>
            </li>
          </ul>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';

export default {
  name: 'Notice',
  data() {
    return {
      userInfo: JwtService.getUserInfo(),
      appNotiList: [],
      uuid: '',
      nowdt: this.$moment(new Date()).format('YYYYMMDD'),
    };
  },
  mounted() {
    this.getUUID();
  },
  watch: {
    uuid() {
      this.getNoti();
    },
  },
  methods: {
    getNoti() {
      if (this.uuid != undefined && this.uuid != '') {
        ApiService.service('POST', 'user/message', {
          request: {
            uuid: this.uuid,
          },
          serviceType: 'app',
        })
          .then(({ data }) => {
            //console.log(data);
            this.appNotiList = data.result;
          })
          .catch(({ response }) => {
            console.log(response);
          });
      }
    },
    getUUID() {
      window.getUUID();
      setTimeout(
        function() {
          this.uuid = window.getUUIDValue();
          return this.uuid;
        }.bind(this),
        100,
      );
    },
    notiDetail(obj) {
      ApiService.service('PUT', 'user/message/modify', {
        request: {
          uuid: obj.uuid,
          msgSeq: obj.msgSeq,
          chgTyp: 'read',
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          if (data.isSucceed) {
            this.$router.push(obj.linkPath);
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    notiAllDel() {
      //전체삭제
      ApiService.service('PUT', 'user/message/modify', {
        request: {
          uuid: this.uuid,
          msgSeq: '',
          chgTyp: 'allDel',
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          this.getNoti();
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    readNotiAllDel() {
      //읽은 알림 삭제
      ApiService.service('PUT', 'user/message/modify', {
        request: {
          uuid: this.uuid,
          msgSeq: '',
          chgTyp: 'readDel',
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          this.getNoti();
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
